import { Link } from "react-router-dom";
import { communityPosts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function RankingSection() {
  const ranked = [...communityPosts].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const maxHeat = ranked[0]?.heat ?? 1;

  return (
    <section className="w-full bg-foreground-950 text-background-100 paper-grain">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] uppercase text-primary-300">
              <i className="ri-line-chart-line"></i>
              Hot Board
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              实时热帖榜 · 围观不迷路
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-300 max-w-xl leading-relaxed">
              综合浏览、点赞、收藏与评论互动计算热度，每隔一段时间刷新一次。
              榜单靠前不代表内容真伪，只代表此刻讨论最热闹。
            </p>
          </div>
          <Link
            to="/hot"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap self-start"
          >
            进入完整榜单
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <ol className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-2">
          {ranked.map((post, index) => (
            <li key={post.id}>
              <Link
                to={`/post/${post.id}`}
                className="group flex items-center gap-4 py-4 border-b border-background-100/12 cursor-pointer"
              >
                <span
                  className={`shrink-0 w-9 h-9 rounded-md flex items-center justify-center font-heading font-bold ${
                    index < 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-50/10 text-background-200"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm md:text-base font-medium text-background-50 group-hover:text-primary-200 transition-colors line-clamp-1">
                    {post.title}
                  </span>
                  <span className="mt-2 flex items-center gap-3">
                    <span className="h-1.5 rounded-full bg-background-100/15 overflow-hidden w-full max-w-[220px]">
                      <span
                        className="block h-full rounded-full bg-primary-400"
                        style={{ width: `${Math.round((post.heat / maxHeat) * 100)}%` }}
                      ></span>
                    </span>
                    <span className="text-xs text-background-300 whitespace-nowrap">
                      {formatCount(post.heat)} 热度
                    </span>
                  </span>
                </span>
                <span className="shrink-0 hidden sm:block text-xs text-background-400 whitespace-nowrap">
                  {post.category}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}